<template>
  <li>
    <div class="item-detail__container">
      <div class="item-detail__info">

        <router-link tag="a" :to="link">
        <div class="flex flex-wrap items-center">
          <div class="item-detail__image">
            <img class="profile-image" :src="talent.profile_image_url">
          </div>
          <div class="item-detail__details">
            <h3>
              {{ talent.name }}
              <i v-if="talent.profile && talent.profile.visibility === 'hidden' && ($userIsAdmin || $userIsManager)" class="fa fa-eye-slash text-grey" aria-label="hidden" title="hidden"/>
              <i v-if="talent.profile && talent.profile.visibility === 'private' && ($userIsAdmin || $userIsManager)" class="fa fa-lock text-grey" aria-label="private" title="private"/>
            </h3>
            <div class="item-detail__meta">
              <div v-if="!$vlastMode"><i class="fa fa-fw fa-calendar"></i> Bookings: {{ talent.uncompleted_bookings }}</div>
              <div v-if="$vlastMode && talent.talent_bookings_count !== null"><i class="fa fa-fw fa-calendar"></i> Bookings: {{ talent.talent_bookings_count }}</div>
              <div v-if="!$vlastMode"><i class="fa fa-fw fa-usd"></i> Requests: {{ talent.requests_pending_response }}</div>
              <div v-if="talent.total_time" title="Total time"><i class="fa fa-clock-o"></i> {{ talent.total_time }}</div>
              <div><i class="fa fa-fw fa-user"></i> Profile: {{ talent.profile_completion_percentage }}%</div>
              <div v-if="$userIsAdmin && talent.self_verified && $route.params.status==='unverified'"><i class="fa fa-fw fa-check"></i> Self Verified </div>
              <template v-if="$userIsAdmin && talent.management">
                <div><i class="fa fa-fw fa-group"></i> {{ talent.management.name }}, {{ talent.management.company}}</div>
              </template>
              <div v-if="$vlastMode && talent.activation_notified_at" ><i class="fa fa-fw fa-clock"></i>Activation Email Sent: {{ talent.activation_notified_at | dateTimezone( $user.timezone, $user.date_format_preference, true, true) }}</div>
            </div>
          </div>
        </div>
      </router-link>

      </div>
      <div class="item-detail__cta">
        <router-link tag="a" v-if="canEdit" :to="{ name: 'talent.profile.show', params: { id: talent.id, status: 'event' }}" class="btn btn-secondary">
          Edit Profile
        </router-link>
        <router-link tag="a" :to="{ name: 'talent.profile.view', params: { id: talent.id, status: 'event' }}" class="btn btn-primary">
          View Profile
        </router-link>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    talent: {
      required: true,
      type: Object
    }
  },
  computed: {
    canEdit () {
      if (this.$userIsGlobalAdmin) {
        return true
      }
      if (this.$userIsManager) {
        return true
      }
      if (this.$userIsRegionalAdmin || this.$userIsSuperRegionalAdmin) {
        return this.talent.region_id === this.$user.region_id
      }
      return false
    },

    link () {
      const link = {
        name: 'talent.profile.view',
        params: { id: this.talent.id }
      }

      if (this.$userIsAdmin) {
        link.params.status = 'event'
      }

      return link
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/bootstrap/variables";

.item-detail {
  &__container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    @media (min-width: 768px) {
      flex-wrap: nowrap;
    }
  }
  &__image {
    flex-shrink: 0;
    width: 4rem;
    margin-right: 1rem;
  }
  &__details {
    h3 {
      width: 100%;
      margin-bottom: 0;
    }
  }
  &__info {
    width: 100%;
    a {
      display: block;
    }
    a:hover {
     h3 {
        color: var(--brand-primary);
        text-decoration: underline;
      }
    }
  }
  &__meta {
    color: $gray-dark;
    text-transform: uppercase;
    font-size: 11px;
    margin: 0 -0.5em 0;
    & > * {
      display: inline-block;
      @media  (max-width: 767px) {
        width: calc(50% - 1em);
      }
    }
  }
  &__cta {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: calc(100% + 10px);
    margin: 30px -5px 0;
    @media (min-width: 375px) and (max-width: 767px) {
      flex-wrap: nowrap;
    }
    @media (min-width: 768px) {
      width: unset;
      margin-left: 30px;
      margin-top: 0;
    }
  }
  .btn {
    font-size: 11px;
    border: none;
    width: 100%;
    color: $gray-dark;
    margin: 5px;
    @media (min-width: 375px) and (max-width: 767px) {
      width: 50%;
    }
    @media (min-width: 768px) {
      width: unset;
    }
    &-primary {
      background: $gray-lighter;
      border: 2px solid $gray-lighter;
      &:hover {
        background: darken($gray-lighter, 10%);
        border-color: darken($gray-lighter, 10%);
      }
    }
    &-secondary {
      border: 2px solid $gray-lighter;
      &:hover {
        background: $gray-lighter;
      }
    }

  }
}
</style>
